import React, { Fragment } from "react";
import ToggleSwitch from "../../components/ToggleSwitch";
import { getApi } from "../../api/endpoints";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const AutoBillFinalizeForm = (props) => {
  const {distributorDetails} = props
  const [canAutoFinalizeBillApi] = getApi('canAutoFinalizeBill');
  const params = useParams();

  const toggleAutoFinalizeState = async (event) => {
    try{
      let response = await canAutoFinalizeBillApi({
        partner_id: params.id,
        partner_role: 'cp',
        bill_status: event.target.checked
      }).unwrap();
      distributorDetails.bill_finalize_by_role = !distributorDetails.bill_finalize_by_role;
      toast.success(response.message);
    }
    catch(error) {
      toast.error(error?.data?.message || 'Something went wrong !');
    }
  }

  return <Fragment>
    <div className="d-flex m-2 justify-content-between">
      <label htmlFor="autofinalize_bill" className="pt-2 fw-bold">Auto finalize bill</label>
      <ToggleSwitch
        id="autofinalize_bill"
        label_left="No"
        label_right ="Yes"
        onChange={(e) => toggleAutoFinalizeState(e)}
        checked={distributorDetails.bill_finalize_by_role}
      />
    </div>
  </Fragment>
}

export default AutoBillFinalizeForm;
